/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { t } from '../../providers';
import ActionButton from '../ActionButton';

const useStyles = makeStyles((theme) => ({
    gridSection: {
        width: 'calc(100% - 20px)',
        padding: '0px',
        marginBottom: '10px',
        '@media (max-width:960px)': { width: 'auto' },
        '& .MuiGrid-container': {
            '@media (max-width:960px)': { justifyContent: 'center' },
        },
    },
    appCard: {
        width: '335px',
        boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2)',
        filter: 'drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.12))',
        borderRadius: '3px',
    },
    imageSection: {
        // width: '335px',
        height: '177px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    infoSection: {
        borderTop: '1px solid #e7e7ed',
        borderBottom: '1px solid #e7e7ed',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 0 10px 16px ',
    },
    detailsSection: {
        padding: '10px 16px',
        height: '306px',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '3px',
            backgroundColor: theme.palette.scrollbar.main,
        },
        '& $detail': { margin: '5px 0' },
    },
    detail: {
        '& .more-less-btn': {
            color: '#3F5E20',
            fontSize: '0.75rem',
            background: '#F7F7F7',
            border: '1px solid #D9D9D9',
            boxSizing: 'border-box',
            borderRadius: '8px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'centeclassification-divr',
            textAlign: 'center',
            padding: '0px 5px 0px 5px',
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
    },
    detailTitle: {
        fontWeight: 'bold',
        fontSize: '0.625rem',
        lineHeight: '15px',
        textTransform: 'uppercase',
        color: theme.palette.text.gridDetailTitle,
        '&.floatLeft': {
            float: 'left',
        },
    },
    detailValue: {
        maxWidth: 'calc(100% - 80px)',
        flexWrap: 'wrap',
        display: 'inline-flex',
        fontSize: '0.75rem',
        lineHeight: '29px',
        color: theme.palette.text.chipgrey,
        marginLeft: '5px',
        '&.status': {
            padding: '0 3px',
            fontWeight: '600',
            fontSize: '0.625rem',
            lineHeight: '20px',
            color: theme.palette.text.mainGreen,
            border: '1px solid ' + theme.palette.text.mainGreen,
            boxSizing: 'border-box',
            borderRadius: '2px',
            textTransform: 'uppercase',
        },
        // application grid classification-item (niceClassification or locarno)
        '& .classification-item': {
            background: theme.palette.text.lightBg,
            border: '1px solid ' + theme.palette.text.lightBg,
            boxSizing: 'border-box',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '0.625rem',
            lineHeight: '20px',
            textTransform: 'uppercase',
            color: theme.palette.text.darkGrey,
            display: 'flex',
            alignItems: 'center',
            marginRight: '5px',
            marginTop: '3px',
            padding: '0 4px',
            float: 'left',
        },
        '& .classification-noItem': {
            background: 'none',
            display: 'flex',
            alignItems: 'center',
            marginRight: '5px',
            padding: '0 4px',
            float: 'left',
            lineHeight: '9px',
        },
        '& .text-ellipsis': {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            width: '163px',
        },
        '& .text-noEllipsis': {
            textOverflow: 'unset',
            whiteSpace: 'normal',
            overflow: 'hidden',
            width: '170px',
            display: 'initial',
        },
        '& .more-less-btn': {
            color: '#3F5E20',
            fontSize: '0.75rem',
            background: '#F7F7F7',
            border: '1px solid #D9D9D9',
            boxSizing: 'border-box',
            borderRadius: '8px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'centeclassification-divr',
            textAlign: 'center',
            padding: '0px 5px 0px 5px',
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
        '& .classification-div': {
            marginTop: '0px',
            width: '193px',
        },
        '&.requestName': {
            maxWidth: '100%',
            lineHeight: '133%',
            display: 'initial',
        },
        '& .generalBtn': {
            color: '#086B9C',
            fontSize: '0.75rem',
            textDecoration: 'underline',
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
    },
    moreLessBtn: {
        color: '#3F5E20',
        fontSize: '0.75rem',
        background: '#F7F7F7',
        border: '1px solid #D9D9D9',
        boxSizing: 'border-box',
        borderRadius: '8px',
        fontWeight: '600',
        display: 'flex',
        alignItems: 'centeclassification-divr',
        textAlign: 'center',
        padding: '0px 5px 0px 5px',
    },
    moreItems: {
        height: '152px',
    },
    moreItemsBtn: {
        '&.MuiIconButton-root': {
            padding: '5px 22px 0px 10px',
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
    },
}));

const ApplicationsGrid = ({ applications, gridId = 'gridId', ariaLabelledby = '' }) => {
    const classes = useStyles();
    const isTablet = useMediaQuery('(max-width:960px)');

    return (
        <div className={classes.gridSection} id={`grid-${gridId}`} role="tabpanel" aria-labelledby={ariaLabelledby}>
            <Grid container direction="row" spacing={3}>
                {(!applications || applications.length === 0) && (
                    <Grid item xs={12} align={isTablet ? 'left' : 'center'}>
                        {t('no.applications')}
                    </Grid>
                )}
                {(applications || []).map((app, appIdx) => {
                    return (
                        <Grid id={`grid-${gridId}-item-${appIdx}`} key={appIdx} item>
                            <Card className={classes.appCard}>
                                {/* image */}
                                <div className={classes.imageSection}>{app.image}</div>

                                {/* info */}
                                <div className={classes.infoSection}>
                                    <div className={classes.moreItems}>
                                        {app.infoSection &&
                                            app.infoSection.map((item, idx) => (
                                                <div key={idx} className={classes.detail}>
                                                    <span className={classes.detailTitle}>{item.label}:</span>
                                                    <span
                                                        className={
                                                            item.extraClass ? [classes.detailValue, item.extraClass].join(' ') : classes.detailValue
                                                        }>
                                                        {item.value}
                                                    </span>
                                                </div>
                                            ))}
                                    </div>
                                    <div className={classes.moreItems}>
                                        <ActionButton
                                            className={classes.moreItemsBtn}
                                            actionButtonId={`grid-${gridId}-actionButton-${app.infoSection[1].value}`}
                                            menuItems={app.menuItems}
                                            appId={appIdx}
                                            requestNumber={app.infoSection[1].value}
                                        />
                                    </div>
                                </div>

                                {/* details */}
                                <div className={classes.detailsSection}>
                                    {app.details &&
                                        app.details
                                            .filter((item) => typeof item === 'object') // display only details items that is type of object
                                            .map((item, idx) => (
                                                <div key={idx} className={classes.detail}>
                                                    <span
                                                        className={
                                                            item.labelExtraClass
                                                                ? [classes.detailTitle, item.labelExtraClass].join(' ')
                                                                : classes.detailTitle
                                                        }>
                                                        {item.label}:
                                                    </span>
                                                    <span
                                                        className={
                                                            item.extraClass ? [classes.detailValue, item.extraClass].join(' ') : classes.detailValue
                                                        }>
                                                        {item.value}
                                                    </span>
                                                    {item.extraElement ? item.extraElement : ''}
                                                </div>
                                            ))}
                                </div>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        </div>
    );
};

export default ApplicationsGrid;
